import { useFinalReceiving } from "@hooks/procurements/procurement/useFinalReceiving";
import { PageHeader, FinalReceivingForm } from "./components";
import { useProcurement } from "@hooks/procurements/procurement/useProcurement";

export interface FinalReceivingProps {
  id: any; //!!!
  setSearchParams?: Function;
  changeActiveTab: (arg: number) => void;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
}

const FinalReceiving = ({
  id,
  changeActiveTab,
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
}: FinalReceivingProps) => {
  const { getSingleData, setGetDataAfterUpdate } = useFinalReceiving(id);

  const { procurementState } = useProcurement();
  const { getSingleData: procurement } = procurementState;

  return (
    <div className="p-10">
      <PageHeader
        changeActiveTab={changeActiveTab}
        procurement={procurement}
        procurementId={id}
      />
      <FinalReceivingForm
        id={id}
        changeActiveTab={changeActiveTab}
        setIsSuccessModalOpen={setIsSuccessModalOpen}
        finalReceiving={getSingleData}
        setIsErrorModalOpen={setIsErrorModalOpen}
        setGetDataAfterUpdate={setGetDataAfterUpdate}
      />
    </div>
  );
};

export default FinalReceiving;
